<script setup lang="ts">
import type BoardBtnButtonUi from './BoardBtnButtonUi.vue'

defineProps<{
  classBtn?: string | string[] | None
  productId: string
  size: 's' | 'm' | 'l'
  qty: number
  right?: boolean
}>()

const t2 = useT2({
  Save: 'Išsaugoti',
  Saved: 'Išsaugota',
})

const auth = useAuth()
const mobile = useMobile()
const init3 = useInited('init3')
const controller = useTemplateRef('controller')
const uiRef = useTemplateRef<InstanceType<typeof BoardBtnButtonUi> | null>('uiRef')
const notify = useNotify({ elem: () => helpers.getHTMLElement(uiRef.value?.button1El ?? uiRef.value) })

const data = shallowReactive({
  doc: undefined as undefined | gen.BuyerBoardCheckFragment,
  modal: false,
  init: false,
})

const boardIds = computed(() => helpers.arr(data.doc?.boardIds))
const isSaved = computed(() => boardIds.value.length > 0)
const label1 = computed(() => (isSaved.value ? t2('Saved') : t2('Save')))

const renderModal = useIsRender(() => data.modal)

function onHover() {
  data.init = true
}
function init(cb: () => void) {
  const prev = data.init
  data.init = true
  window.setTimeout(() => cb(), prev ? 0 : 50)
}
function recheck() {
  init(() => controller.value?.recheck())
}
function click1() {
  init(() => {
    if (mobile.value || !auth.value.isAuth) data.modal = true
    else controller.value?.toggleSave()
  })
}
const modal = computed({
  get: () => data.modal,
  set: (i) => init(() => (data.modal = i)),
})
</script>

<template>
  <BoardBtnButtonUi ref="uiRef" :size :classBtn :right :on="isSaved" :opened="modal" :label1 :click1 :click2="() => (modal = !modal)" @mouseenter.once.passive="onHover">
    <template #icon="{ iconCss }">
      <span v-if="init3" class="_svg18">
        <LazyIconSave :class="iconCss" />
      </span>
    </template>

    <template #expandable="{ cssIcon, cssLabel }">
      <template v-if="init3">
        <LazyIconChevron v-if="!boardIds.length" :open="modal" :class="cssIcon" />
        <LazyIconCheck v-else :class="cssIcon" />
      </template>
      <LazyBoardBtnButton2 ref="controller" :notify v-if="data.init" :product-id :qty :class="cssLabel" v-model="data.doc" :active="data.init" />
    </template>

    <template #after>
      <LazyBoardModal v-if="renderModal" v-model:open="modal" :recheck :quantity="qty" :product-id :active-boards="boardIds" :elem="() => uiRef?.button1El" />
      <UiNotify :notify />
    </template>
  </BoardBtnButtonUi>
</template>
